import { cva, type VariantProps } from 'class-variance-authority';

export { CharlieBadge } from './charlie-badge.js';

export const charlieBadgeVariants = cva(
  'inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none overflow-hidden',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
        destructive:
          'border-transparent bg-destructive text-white dark:bg-destructive/60',
        outline: 'text-foreground',
        success: 'border-success bg-success/5 text-success',
        warning: 'border-warning bg-warning/5 text-warning',
        info: 'border-info bg-info/5 text-info',
        critical: 'border-destructive bg-destructive/5 text-destructive',
        neutral: 'border-border bg-muted text-muted-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export type CharlieBadgeVariants = VariantProps<typeof charlieBadgeVariants>;

export type CharlieBadgeProps = React.HTMLAttributes<HTMLSpanElement> & {
  /** The colour, from the theme tokens. */
  variant?: CharlieBadgeVariants['variant'];
};
